import React from 'react'
import PropTypes from 'prop-types'

function YankeeStep(props) {

    const{page} = props
    // console.log('page' , page)
  return (
    <div className='container'>
   <div className="row justify-content-center"><div className="col-md-10"> 
    <div className="stpes-Design stpes-Design-yankees">
        <div className={page == 'home' ? 'bullet active' : 'bullet'}>
            <div className="box">
                <span>1</span>
            </div>
        </div>
        <div className={page == 'signup' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>2</span> </div>
        </div>
        <div className={page == 'driver' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>3</span> </div>
        </div>
        <div className={page == 'pass' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>4</span> </div>
        </div>
        <div className={page == 'thankyou' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>5</span> </div>
        </div>
    </div>
   </div>
    </div>
    </div>

  )
}
YankeeStep.propTypes = {
    page: PropTypes.string,
    paymentStatus: PropTypes.bool
}

YankeeStep.defaulProps = {
	page:undefined,
  paymentStatus: false
}
export default YankeeStep
